var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/data/AgentRateType.ts
var AgentRateType;
(function(AgentRateType2) {
  AgentRateType2["flex"] = "flex";
  AgentRateType2["net"] = "net";
  AgentRateType2["gross"] = "gross";
})(AgentRateType || (AgentRateType = {}));
var stringToAgentRateType = /* @__PURE__ */ __name((input) => {
  let rateType;
  const rateTypeString = input?.toLowerCase() || "";
  if (rateTypeString.includes("flex")) {
    rateType = "flex";
  } else if (rateTypeString.includes("net")) {
    rateType = "net";
  } else if (rateTypeString.includes("gross")) {
    rateType = "gross";
  }
  return rateType;
}, "stringToAgentRateType");
var AgentRateType_default = AgentRateType;

// src/data/AgentPaymentType.ts
var AgentPaymentType;
(function(AgentPaymentType2) {
  AgentPaymentType2["full"] = "full";
  AgentPaymentType2["commissionOnly"] = "commission-only";
  AgentPaymentType2["zeroPayment"] = "zero-payment";
  AgentPaymentType2["commissionItems"] = "commission-items";
})(AgentPaymentType || (AgentPaymentType = {}));
var agentPaymentIdToType = /* @__PURE__ */ __name((id) => {
  switch (id) {
    case 1: {
      return "full";
    }
    case 2: {
      return "commission-only";
    }
    case 3: {
      return "zero-payment";
    }
    case 4: {
      return "commission-items";
    }
    default: {
      return null;
    }
  }
}, "agentPaymentIdToType");
var AgentPaymentType_default = AgentPaymentType;

// src/data/AvailabilityType.ts
var AvailabilityType;
(function(AvailabilityType2) {
  AvailabilityType2["freeSell"] = "free-sell";
  AvailabilityType2["onRequest"] = "on-request";
  AvailabilityType2["stopSell"] = "stop-sell";
})(AvailabilityType || (AvailabilityType = {}));
var AvailabilityType_default = AvailabilityType;

// src/data/JucyCountryCode.ts
var JucyCountryCode;
(function(JucyCountryCode2) {
  JucyCountryCode2["au"] = "au";
  JucyCountryCode2["nz"] = "nz";
})(JucyCountryCode || (JucyCountryCode = {}));
var JucyCountryCode_default = JucyCountryCode;

// src/data/ReservationStatusType.ts
var ReservationStatusType;
(function(ReservationStatusType2) {
  ReservationStatusType2["quotation"] = "quote";
  ReservationStatusType2["confirmed"] = "confirmed";
  ReservationStatusType2["hired"] = "hired";
  ReservationStatusType2["cancelled"] = "cancelled";
  ReservationStatusType2["maintenance"] = "maintenance";
  ReservationStatusType2["returned"] = "returned";
  ReservationStatusType2["onRequest"] = "on-request";
})(ReservationStatusType || (ReservationStatusType = {}));
var stringToReservationStatusType = /* @__PURE__ */ __name((input) => {
  let statusType;
  const rateTypeString = input?.toLowerCase().replace(/[^a-z]/, "") || "";
  if (rateTypeString === "quotation") {
    statusType = "quote";
  } else if (rateTypeString === "reservation") {
    statusType = "confirmed";
  } else if (rateTypeString === "hired") {
    statusType = "hired";
  } else if (rateTypeString === "cancelled") {
    statusType = "cancelled";
  } else if (rateTypeString === "maintenance") {
    statusType = "maintenance";
  } else if (rateTypeString === "reservationrequest") {
    statusType = "on-request";
  } else if (rateTypeString === "returned") {
    statusType = "returned";
  }
  return statusType;
}, "stringToReservationStatusType");
var ReservationStatusType_default = ReservationStatusType;

// src/data/branchTimezones.ts
var branchTimezones = /* @__PURE__ */ new Map([
  //NZST
  [
    "AKL",
    "Pacific/Auckland"
  ],
  [
    "AAP",
    "Pacific/Auckland"
  ],
  [
    "CHC",
    "Pacific/Auckland"
  ],
  [
    "WLG",
    "Pacific/Auckland"
  ],
  [
    "ZQN",
    "Pacific/Auckland"
  ],
  //AEST
  [
    "SYD",
    "Australia/Sydney"
  ],
  [
    "LSY",
    "Australia/Sydney"
  ],
  [
    "CBR",
    "Australia/Sydney"
  ],
  [
    "MEL",
    "Australia/Melbourne"
  ],
  [
    "MAP",
    "Australia/Melbourne"
  ],
  [
    "OOL",
    "Australia/Brisbane"
  ],
  [
    "BNE",
    "Australia/Brisbane"
  ],
  //ACST
  [
    "ADL",
    "Australia/Adelaide"
  ],
  [
    "LCN",
    "Australia/Adelaide"
  ],
  [
    "CNS",
    "Australia/Adelaide"
  ],
  [
    "ASP",
    "Australia/Darwin"
  ],
  [
    "DRW",
    "Australia/Darwin"
  ],
  //AWST
  [
    "LPE",
    "Australia/Perth"
  ],
  [
    "PER",
    "Australia/Perth"
  ],
  //AEDT
  [
    "HBA",
    "Australia/Hobart"
  ]
]);
var branchTimezones_default = branchTimezones;

// src/data/branches.ts
var auBranch = {
  country: "Australia",
  countryCode: JucyCountryCode_default.au,
  businessUnitId: "e10d8f7c-67e4-4bff-b23f-e86183653aa5",
  currencyCode: "AUD",
  timezone: ""
};
var nzBranch = {
  country: "New Zealand",
  countryCode: JucyCountryCode_default.nz,
  businessUnitId: "ee7e4270-2972-e711-811e-e0071b67c991",
  currencyCode: "NZD",
  timezone: ""
};
var branches = [
  // Australia
  {
    active: true,
    code: "ADL",
    name: "Adelaide Airport",
    rcmId: 14,
    id: "ed5ebb4e-7aa8-11e9-8f9e-2a86e4085a59",
    ...auBranch
  },
  {
    active: false,
    code: "ASP",
    name: "Alice Springs",
    rcmId: 23,
    id: "4fcda9d9-4e12-4146-bae8-e600b5962dce",
    ...auBranch
  },
  {
    active: true,
    code: "BNE",
    name: "Brisbane",
    rcmId: 1,
    id: "d1deb61d-ff25-45bb-b600-ec9474efedae",
    ...auBranch
  },
  {
    active: true,
    code: "CBR",
    name: "Canberra",
    rcmId: 4,
    id: "558e4927-df64-4671-acfc-aa86b0c9565c",
    ...auBranch
  },
  {
    active: true,
    code: "CNS",
    name: "Cairns",
    rcmId: 3,
    id: "3eec06c6-43ec-4ecb-bab3-2ea4c1d50412",
    ...auBranch
  },
  {
    active: true,
    code: "DRW",
    name: "Darwin",
    rcmId: 22,
    id: "200f3081-e6d0-496f-9836-2b6b0a3d726f",
    ...auBranch
  },
  {
    active: false,
    code: "HBA",
    name: "Hobart Airport",
    rcmId: 21,
    id: "cc6dda00-4f0a-4225-9473-eca0b3c0ce3c",
    ...auBranch
  },
  {
    active: true,
    code: "MAP",
    name: "Melbourne Airport",
    rcmId: 13,
    id: "2d7cbe80-1fbd-4df4-aa1e-6885345fb1fd",
    ...auBranch
  },
  {
    active: false,
    code: "MEL",
    name: "Melbourne City",
    rcmId: 7,
    id: "f3299622-c227-4013-8738-c28f50510a73",
    ...auBranch
  },
  {
    active: true,
    code: "OOL",
    name: "Gold Coast",
    rcmId: 15,
    id: "3945659b-cf31-477e-9a26-a00cde64e6ab",
    ...auBranch
  },
  {
    active: true,
    code: "PER",
    name: "Perth Airport",
    rcmId: 20,
    id: "b23abb38-face-41a1-8a82-9f131cfeb2be",
    ...auBranch
  },
  {
    active: true,
    code: "SYD",
    name: "Sydney",
    rcmId: 2,
    id: "4f333b95-e1a6-488d-be0a-193b24eddaed",
    ...auBranch
  },
  // New Zealand
  {
    active: true,
    code: "AAP",
    name: "Auckland Airport",
    rcmId: 7,
    id: "d7d69fd9-a986-e611-80ed-c4346bc5779c",
    ...nzBranch
  },
  {
    active: false,
    code: "AKL",
    name: "Auckland City",
    rcmId: 1,
    id: "d045b103-ab86-e611-80ed-c4346bc5779c",
    ...nzBranch
  },
  {
    active: false,
    code: "CHC",
    name: "Christchurch Airport",
    rcmId: 8,
    id: "64bf2423-ac86-e611-80ed-c4346bc5779c",
    ...nzBranch
  },
  {
    active: false,
    code: "WLG",
    name: "Wellington Airport",
    rcmId: 9,
    id: "caef6d6e-ad86-e611-80ed-c4346bc5779c",
    ...nzBranch
  },
  {
    active: true,
    code: "ZQN",
    name: "Queenstown Airport",
    rcmId: 10,
    id: "8e4e4d28-ad86-e611-80ed-c4346bc5779c",
    ...nzBranch
  }
];
branches.forEach((site) => {
  site.timezone = branchTimezones_default.get(site.code) || "";
});
var branches_default = branches;

// src/data/businessUnits.ts
var businessUnits = [
  {
    code: "JUCYAU",
    name: "JUCY AU",
    id: "e10d8f7c-67e4-4bff-b23f-e86183653aa5",
    salesTaxPercentage: 10,
    country: "Australia",
    countryCode: JucyCountryCode_default.au
  },
  {
    code: "JUCYNZ",
    name: "JUCY NZ",
    id: "ee7e4270-2972-e711-811e-e0071b67c991",
    salesTaxPercentage: 15,
    country: "New Zealand",
    countryCode: JucyCountryCode_default.nz
  },
  {
    code: "STARAU",
    name: "StarRV AU",
    id: "5213ece7-82c2-4b43-be21-236c86bfc50b",
    salesTaxPercentage: 10,
    country: "Australia",
    countryCode: JucyCountryCode_default.au
  },
  {
    code: "STARNZ",
    name: "StarRV NZ",
    id: "1821eeea-2dc8-41a8-8f49-85a4d18c0e70",
    salesTaxPercentage: 15,
    country: "New Zealand",
    countryCode: JucyCountryCode_default.nz
  }
];
var businessUnits_default = businessUnits;

// src/data/Countries.ts
var countries = [
  {
    name: "New Zealand",
    code: "NZL"
  },
  {
    name: "United States",
    code: "USA"
  },
  {
    name: "United Kingdom",
    code: "GBR"
  },
  {
    name: "Afghanistan",
    code: "AFG"
  },
  {
    name: "Albania",
    code: "ALB"
  },
  {
    name: "Algeria",
    code: "DZA"
  },
  {
    name: "Andorra",
    code: "AND"
  },
  {
    name: "Angola",
    code: "AGO"
  },
  {
    name: "Antigua and Barbuda",
    code: "ATG"
  },
  {
    name: "Argentina",
    code: "ARG"
  },
  {
    name: "Armenia",
    code: "ARM"
  },
  {
    name: "Australia",
    code: "AUS"
  },
  {
    name: "Austria",
    code: "AUT"
  },
  {
    name: "Azerbaijan",
    code: "AZE"
  },
  {
    name: "Bahamas",
    code: "BHS"
  },
  {
    name: "Bahrain",
    code: "BHR"
  },
  {
    name: "Bangladesh",
    code: "BGD"
  },
  {
    name: "Barbados",
    code: "BRB"
  },
  {
    name: "Belarus",
    code: "BLR"
  },
  {
    name: "Belgium",
    code: "BEL"
  },
  {
    name: "Belize",
    code: "BLZ"
  },
  {
    name: "Benin",
    code: "BEN"
  },
  {
    name: "Bermuda",
    code: "BMU"
  },
  {
    name: "Bhutan",
    code: "BTN"
  },
  {
    name: "Bolivia",
    code: "BOL"
  },
  {
    name: "Bosnia and Herzegovina",
    code: "BIH"
  },
  {
    name: "Botswana",
    code: "BWA"
  },
  {
    name: "Brazil",
    code: "BRA"
  },
  {
    name: "Brunei",
    code: "BRN"
  },
  {
    name: "Bulgaria",
    code: "BGR"
  },
  {
    name: "Burkina Faso",
    code: "BFA"
  },
  {
    name: "Burundi",
    code: "BDI"
  },
  {
    name: "Cabo Verde",
    code: "CPV"
  },
  {
    name: "Cambodia",
    code: "KHM"
  },
  {
    name: "Cameroon",
    code: "CMR"
  },
  {
    name: "Canada",
    code: "CAN"
  },
  {
    name: "Cayman Islands",
    code: "CYM"
  },
  {
    name: "Central African Republic (CAR)",
    code: "CAF"
  },
  {
    name: "Chad",
    code: "TCD"
  },
  {
    name: "Chile",
    code: "CHL"
  },
  {
    name: "China",
    code: "CHN"
  },
  {
    name: "Christmas Island",
    code: "CXR"
  },
  {
    name: "Colombia",
    code: "COL"
  },
  {
    name: "Comoros",
    code: "COM"
  },
  {
    name: "Cook Islands",
    code: "COK"
  },
  {
    name: "Costa Rica",
    code: "CRI"
  },
  {
    name: "C\xF4te d'Ivoire",
    code: "CIV"
  },
  {
    name: "Croatia",
    code: "HRV"
  },
  {
    name: "Cuba",
    code: "CUB"
  },
  {
    name: "Cyprus",
    code: "CYP"
  },
  {
    name: "Czech Republic",
    code: "CZE"
  },
  {
    name: "Democratic Republic of theCongo",
    code: "COD"
  },
  {
    name: "Denmark",
    code: "DNK"
  },
  {
    name: "Djibouti",
    code: "DJI"
  },
  {
    name: "Dominica",
    code: "DMA"
  },
  {
    name: "Dominican Republic",
    code: "DOM"
  },
  {
    name: "Ecuador",
    code: "ECU"
  },
  {
    name: "Egypt",
    code: "EGY"
  },
  {
    name: "El Salvador",
    code: "SLV"
  },
  {
    name: "Equatorial Guinea",
    code: "GNQ"
  },
  {
    name: "Eritrea",
    code: "ERI"
  },
  {
    name: "Estonia",
    code: "EST"
  },
  {
    name: "Ethiopia",
    code: "ETH"
  },
  {
    name: "Fiji",
    code: "FJI"
  },
  {
    name: "Finland",
    code: "FIN"
  },
  {
    name: "France",
    code: "FRA"
  },
  {
    name: "Gabon",
    code: "GAB"
  },
  {
    name: "Gambia",
    code: "GMB"
  },
  {
    name: "Georgia",
    code: "GEO"
  },
  {
    name: "Germany",
    code: "DEU"
  },
  {
    name: "Ghana",
    code: "GHA"
  },
  {
    name: "Gibraltar",
    code: "GIB"
  },
  {
    name: "Greece",
    code: "GRC"
  },
  {
    name: "Greenland",
    code: "GRL"
  },
  {
    name: "Grenada",
    code: "GRD"
  },
  {
    name: "Guadeloupe",
    code: "GLP"
  },
  {
    name: "Guam",
    code: "GUM"
  },
  {
    name: "Guatemala",
    code: "GTM"
  },
  {
    name: "Guernsey",
    code: "GGY"
  },
  {
    name: "Guinea",
    code: "GIN"
  },
  {
    name: "Guinea-Bissau",
    code: "GNB"
  },
  {
    name: "Guyana",
    code: "GUY"
  },
  {
    name: "Haiti",
    code: "HTI"
  },
  {
    name: "Honduras",
    code: "HND"
  },
  {
    name: "Hong Kong",
    code: "HKG"
  },
  {
    name: "Hungary",
    code: "HUN"
  },
  {
    name: "Iceland",
    code: "ISL"
  },
  {
    name: "India",
    code: "IND"
  },
  {
    name: "Indonesia",
    code: "IDN"
  },
  {
    name: "Iran",
    code: "IRN"
  },
  {
    name: "Iraq",
    code: "IRQ"
  },
  {
    name: "Ireland",
    code: "IRL"
  },
  {
    name: "Isle of Man",
    code: "IMN"
  },
  {
    name: "Israel",
    code: "ISR"
  },
  {
    name: "Italy",
    code: "ITA"
  },
  {
    name: "Jamaica",
    code: "JAM"
  },
  {
    name: "Japan",
    code: "JPN"
  },
  {
    name: "Jordan",
    code: "JOR"
  },
  {
    name: "Kazakhstan",
    code: "KAZ"
  },
  {
    name: "Kenya",
    code: "KEN"
  },
  {
    name: "Kiribati",
    code: "KIR"
  },
  {
    name: "Kosovo",
    code: "UNK"
  },
  {
    name: "Kuwait",
    code: "KWT"
  },
  {
    name: "Kyrgyzstan",
    code: "KGZ"
  },
  {
    name: "Laos",
    code: "LAO"
  },
  {
    name: "Latvia",
    code: "LVA"
  },
  {
    name: "Lebanon",
    code: "LBN"
  },
  {
    name: "Lesotho",
    code: "LSO"
  },
  {
    name: "Liberia",
    code: "LBR"
  },
  {
    name: "Libya",
    code: "LBY"
  },
  {
    name: "Liechtenstein",
    code: "LIE"
  },
  {
    name: "Lithuania",
    code: "LTU"
  },
  {
    name: "Luxembourg",
    code: "LUX"
  },
  {
    name: "Macau",
    code: "MAC"
  },
  {
    name: "Macedonia",
    code: "MKD"
  },
  {
    name: "Madagascar",
    code: "MDG"
  },
  {
    name: "Malawi",
    code: "MWI"
  },
  {
    name: "Malaysia",
    code: "MYS"
  },
  {
    name: "Maldives",
    code: "MDV"
  },
  {
    name: "Mali",
    code: "MLI"
  },
  {
    name: "Malta",
    code: "MLT"
  },
  {
    name: "Marshall Islands",
    code: "MHL"
  },
  {
    name: "Martinique",
    code: "MTQ"
  },
  {
    name: "Mauritania",
    code: "MRT"
  },
  {
    name: "Mauritius",
    code: "MUS"
  },
  {
    name: "Mayotte",
    code: "MYT"
  },
  {
    name: "Mexico",
    code: "MEX"
  },
  {
    name: "Micronesia",
    code: "FSM"
  },
  {
    name: "Moldova",
    code: "MDA"
  },
  {
    name: "Monaco",
    code: "MCO"
  },
  {
    name: "Mongolia",
    code: "MNG"
  },
  {
    name: "Montenegro",
    code: "MNE"
  },
  {
    name: "Morocco",
    code: "MAR"
  },
  {
    name: "Mozambique",
    code: "MOZ"
  },
  {
    name: "Myanmar (Burma)",
    code: "MMR"
  },
  {
    name: "Namibia",
    code: "NAM"
  },
  {
    name: "Nauru",
    code: "NRU"
  },
  {
    name: "Nepal",
    code: "NPL"
  },
  {
    name: "Netherlands",
    code: "NLD"
  },
  {
    name: "Netherlands Antilles",
    code: "ANT"
  },
  {
    name: "New Caledonia",
    code: "NCL"
  },
  {
    name: "Nicaragua",
    code: "NIC"
  },
  {
    name: "Niger",
    code: "NER"
  },
  {
    name: "Nigeria",
    code: "NGA"
  },
  {
    name: "Niue",
    code: "NIU"
  },
  {
    name: "North Korea",
    code: "PRK"
  },
  {
    name: "Norway",
    code: "NOR"
  },
  {
    name: "Oman",
    code: "OMN"
  },
  {
    name: "Pakistan",
    code: "PAK"
  },
  {
    name: "Palau",
    code: "PLW"
  },
  {
    name: "Palestine",
    code: "PSE"
  },
  {
    name: "Panama",
    code: "PAN"
  },
  {
    name: "Papua New Guinea",
    code: "PNG"
  },
  {
    name: "Paraguay",
    code: "PRY"
  },
  {
    name: "Peru",
    code: "PER"
  },
  {
    name: "Philippines",
    code: "PHL"
  },
  {
    name: "Poland",
    code: "POL"
  },
  {
    name: "French Polynesia",
    code: "PYF"
  },
  {
    name: "Portugal",
    code: "PRT"
  },
  {
    name: "Puerto Rico",
    code: "PRI"
  },
  {
    name: "Qatar",
    code: "QAT"
  },
  {
    name: "Republic of the Congo",
    code: "COG"
  },
  {
    name: "Reunion",
    code: "REU"
  },
  {
    name: "Romania",
    code: "ROU"
  },
  {
    name: "Russia",
    code: "RUS"
  },
  {
    name: "Rwanda",
    code: "RWA"
  },
  {
    name: "Saint Kitts and Nevis",
    code: "KNA"
  },
  {
    name: "Saint Lucia",
    code: "LCA"
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VCT"
  },
  {
    name: "Samoa",
    code: "WSM"
  },
  {
    name: "San Marino",
    code: "SMR"
  },
  {
    name: "Sao Tome and Principe",
    code: "STP"
  },
  {
    name: "Saudi Arabia",
    code: "SAU"
  },
  {
    name: "Senegal",
    code: "SEN"
  },
  {
    name: "Serbia",
    code: "SRB"
  },
  {
    name: "Montenegro",
    code: "MNE"
  },
  {
    name: "Seychelles",
    code: "SYC"
  },
  {
    name: "Sierra Leone",
    code: "SLE"
  },
  {
    name: "Singapore",
    code: "SGP"
  },
  {
    name: "Slovakia",
    code: "SVK"
  },
  {
    name: "Slovenia",
    code: "SVN"
  },
  {
    name: "Solomon Islands",
    code: "SLB"
  },
  {
    name: "Somalia",
    code: "SOM"
  },
  {
    name: "South Africa",
    code: "ZAF"
  },
  {
    name: "South Korea",
    code: "KOR"
  },
  {
    name: "South Sudan",
    code: "SSD"
  },
  {
    name: "Spain",
    code: "ESP"
  },
  {
    name: "Sri Lanka",
    code: "LKA"
  },
  {
    name: "Sudan",
    code: "SDN"
  },
  {
    name: "Suriname",
    code: "SUR"
  },
  {
    name: "Swaziland",
    code: "SWZ"
  },
  {
    name: "Sweden",
    code: "SWE"
  },
  {
    name: "Switzerland",
    code: "CHE"
  },
  {
    name: "Syria",
    code: "SYR"
  },
  {
    name: "Taiwan",
    code: "TWN"
  },
  {
    name: "Tajikistan",
    code: "TJK"
  },
  {
    name: "Tanzania",
    code: "TZA"
  },
  {
    name: "Thailand",
    code: "THA"
  },
  {
    name: "Timor-Leste",
    code: "TLS"
  },
  {
    name: "Togo",
    code: "TGO"
  },
  {
    name: "Tokelau",
    code: "TKL"
  },
  {
    name: "Tonga",
    code: "TON"
  },
  {
    name: "Trinidad and Tobago",
    code: "TTO"
  },
  {
    name: "Tunisia",
    code: "TUN"
  },
  {
    name: "Turkey",
    code: "TUR"
  },
  {
    name: "Turkmenistan",
    code: "TKM"
  },
  {
    name: "Tuvalu",
    code: "TUV"
  },
  {
    name: "Uganda",
    code: "UGA"
  },
  {
    name: "Ukraine",
    code: "UKR"
  },
  {
    name: "United Arab Emirates",
    code: "ARE"
  },
  {
    name: "Uruguay",
    code: "URY"
  },
  {
    name: "Uzbekistan",
    code: "UZB"
  },
  {
    name: "Vanuatu",
    code: "VUT"
  },
  {
    name: "Vatican City (Holy See)",
    code: "VAT"
  },
  {
    name: "Venezuela",
    code: "VEN"
  },
  {
    name: "Vietnam",
    code: "VNM"
  },
  {
    name: "Virgin Islands",
    code: "VIR"
  },
  {
    name: "Yemen",
    code: "YEM"
  },
  {
    name: "Zambia",
    code: "ZMB"
  },
  {
    name: "Zimbabwe",
    code: "ZWE"
  }
];
var Countries_default = countries;

// src/data/countryWhiteList.ts
var countryWhiteList = [
  "New Zealand",
  "Australia",
  "United States",
  "United Kingdom"
];
var countryWhiteList_default = countryWhiteList;

// src/data/fleetTypes.ts
var FleetTypeSlug;
(function(FleetTypeSlug2) {
  FleetTypeSlug2["car"] = "car";
  FleetTypeSlug2["campervan"] = "campervan";
  FleetTypeSlug2["motorhome"] = "motorhome";
})(FleetTypeSlug || (FleetTypeSlug = {}));
var fleetTypes = [
  {
    slug: "campervan",
    name: "Campervan",
    rcmId: {
      nz: 2,
      au: 1
    },
    id: "7d3dece7-ab86-e611-80e8-c4346bc5977c",
    leadTimeHours: 2,
    depositPercent: 0.2,
    minHireDays: 1,
    defaultMinimumLeadTimeHours: 2
  },
  {
    slug: "motorhome",
    name: "Motorhome",
    rcmId: {
      nz: 3,
      au: 17
    },
    id: "7f6a1e49-d686-4e0b-8302-d58d26606420",
    leadTimeHours: 2,
    depositPercent: 0.2,
    minHireDays: 1,
    defaultMinimumLeadTimeHours: 2
  },
  {
    slug: "car",
    name: "Car",
    rcmId: {
      nz: 1,
      au: 16
    },
    id: "9972e1db-ab86-e611-80e8-c4346bc5977c",
    leadTimeHours: 1,
    depositPercent: 0.2,
    minHireDays: 1,
    defaultMinimumLeadTimeHours: 1
  }
];
var fleetTypes_default = fleetTypes;

// src/data/fleetCategories.ts
var FleetCategories = [
  //Campers
  {
    active: true,
    code: "CHSR",
    name: "Chaser",
    rcmId: {
      au: null,
      nz: 4
    },
    id: "fd59b647-ec88-e611-80e7-c4346bc5b2d4",
    rcmTypeId: {
      au: 1,
      nz: 2
    },
    fleetType: FleetTypeSlug.campervan,
    fleetTypeId: "7d3dece7-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: true,
    code: "CMPS",
    name: "Compass",
    rcmId: {
      au: 23,
      nz: null
    },
    id: "eebeeb0a-881b-4490-9aed-5772b5352715",
    rcmTypeId: {
      au: 1,
      nz: 2
    },
    fleetType: FleetTypeSlug.campervan,
    fleetTypeId: "7d3dece7-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: true,
    code: "CNDO",
    name: "Condo",
    rcmId: {
      au: 10,
      nz: 3
    },
    id: "ab64e8d1-1f13-4b72-b8f3-8c17e11727e7",
    rcmTypeId: {
      au: 1,
      nz: 2
    },
    fleetType: FleetTypeSlug.campervan,
    fleetTypeId: "7d3dece7-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: true,
    code: "CRBP",
    name: "Crib+",
    rcmId: {
      au: 21,
      nz: null
    },
    id: "198236bc-8c53-4c68-bed1-c22003e41a6f",
    rcmTypeId: {
      au: 1,
      nz: 2
    },
    fleetType: FleetTypeSlug.campervan,
    fleetTypeId: "7d3dece7-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: true,
    code: "CRIB",
    name: "Crib",
    rcmId: {
      au: 1,
      nz: 2
    },
    id: "69932050-6667-4d56-ac15-733f824ea168",
    rcmTypeId: {
      au: 1,
      nz: 2
    },
    fleetType: FleetTypeSlug.campervan,
    fleetTypeId: "7d3dece7-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: false,
    code: "CBNA",
    name: "Cabana",
    rcmId: {
      au: null,
      nz: 2
    },
    id: "ee8a6517-ec88-e611-80e7-c4346bc5b2d4",
    rcmTypeId: {
      au: 1,
      nz: 2
    },
    fleetType: FleetTypeSlug.campervan,
    fleetTypeId: "7d3dece7-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: true,
    code: "CSTR",
    name: "Coaster",
    rcmId: {
      au: 24,
      nz: null
    },
    id: "ed180518-cad1-11e9-8cd6-ef6b9e9209cf",
    rcmTypeId: {
      au: 1,
      nz: 2
    },
    fleetType: FleetTypeSlug.campervan,
    fleetTypeId: "7d3dece7-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: false,
    code: "ECSL",
    name: "El Cheapo Sleeper",
    rcmId: {
      au: 9,
      nz: null
    },
    id: "61b3e228-bb25-41af-9e97-f49ae1c4d32a",
    rcmTypeId: {
      au: 1,
      nz: 2
    },
    fleetType: FleetTypeSlug.campervan,
    fleetTypeId: "7d3dece7-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: false,
    code: "JCEV",
    name: "Jucy EV",
    rcmId: {
      au: null,
      nz: 8
    },
    id: "f09bb2e2-a1bf-e911-a85f-000d3ae023c2",
    rcmTypeId: {
      au: 1,
      nz: 2
    },
    fleetType: FleetTypeSlug.campervan,
    fleetTypeId: "7d3dece7-ab86-e611-80e8-c4346bc5977c"
  },
  //Motorhomes
  {
    active: true,
    code: "PLS4",
    name: "Polaris 4",
    rcmId: {
      au: 27,
      nz: 18
    },
    id: "8e15015f-56a7-4387-8541-407245b5e7e5",
    rcmTypeId: {
      au: 17,
      nz: 3
    },
    fleetType: FleetTypeSlug.motorhome,
    fleetTypeId: "7f6a1e49-d686-4e0b-8302-d58d26606420"
  },
  {
    active: true,
    code: "PLS6",
    name: "Polaris 6",
    rcmId: {
      au: 26,
      nz: 17
    },
    id: "ef633a39-a859-4431-8b91-fec6ff0917a5",
    rcmTypeId: {
      au: 17,
      nz: 3
    },
    fleetType: FleetTypeSlug.motorhome,
    fleetTypeId: "7f6a1e49-d686-4e0b-8302-d58d26606420"
  },
  //Cars
  {
    active: true,
    code: "CFAR",
    name: "Compact SUV",
    rcmId: {
      au: 25,
      nz: 16
    },
    id: "1df4858e-94ca-e811-8162-480fcff12ac1",
    rcmTypeId: {
      au: 16,
      nz: 1
    },
    fleetType: FleetTypeSlug.car,
    fleetTypeId: "9972e1db-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: true,
    code: "EDAR",
    name: "Small Hatch",
    rcmId: {
      au: 14,
      nz: 6
    },
    id: "8a71c203-6c2f-44e1-8ba2-ce6d2ff11529",
    rcmTypeId: {
      au: 16,
      nz: 1
    },
    fleetType: FleetTypeSlug.car,
    fleetTypeId: "9972e1db-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: true,
    code: "IDAR",
    name: "El Cheapo Sedan",
    rcmId: {
      au: 13,
      nz: null
    },
    id: "9a634f4f-7638-42eb-aaef-e2a67b233d1d",
    rcmTypeId: {
      au: 16,
      nz: 1
    },
    fleetType: FleetTypeSlug.car,
    fleetTypeId: "9972e1db-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: true,
    code: "CDAR",
    name: "Mid Hatch",
    rcmId: {
      au: 12,
      nz: null
    },
    id: "23f99f11-d120-44a6-a5be-892fc80a6e33",
    rcmTypeId: {
      au: 16,
      nz: 1
    },
    fleetType: FleetTypeSlug.car,
    fleetTypeId: "9972e1db-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: false,
    code: "CMXR",
    name: "El Cheapo",
    rcmId: {
      au: null,
      nz: 5
    },
    id: "9f9f109d-eb88-e611-80ed-c4346bc5779c",
    rcmTypeId: {
      au: 16,
      nz: 1
    },
    fleetType: FleetTypeSlug.car,
    fleetTypeId: "9972e1db-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: false,
    code: "FZAR",
    name: "JUCY Ski Wagon",
    rcmId: {
      au: null,
      nz: 11
    },
    id: "a25ae429-f13f-4d4e-9e01-03e774990269",
    rcmTypeId: {
      au: 16,
      nz: 1
    },
    fleetType: FleetTypeSlug.car,
    fleetTypeId: "9972e1db-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: false,
    code: "IFAR",
    name: "SUV",
    rcmId: {
      au: null,
      nz: null
    },
    id: "7f3c3a5a-eb88-e611-80ed-c4346bc5779c",
    rcmTypeId: {
      au: 16,
      nz: 1
    },
    fleetType: FleetTypeSlug.car,
    fleetTypeId: "9972e1db-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: false,
    code: "MVAR",
    name: "8 Seater Van",
    rcmId: {
      au: 15,
      nz: 7
    },
    id: "8af45371-5d29-4d47-af2f-538803822369",
    rcmTypeId: {
      au: 16,
      nz: 1
    },
    fleetType: FleetTypeSlug.car,
    fleetTypeId: "9972e1db-ab86-e611-80e8-c4346bc5977c"
  },
  {
    active: false,
    code: "XVAR",
    name: "10 Seata",
    rcmId: {
      au: null,
      nz: null
    },
    id: "4af6dec8-ea88-e611-80ed-c4346bc5779c",
    rcmTypeId: {
      au: 16,
      nz: 1
    },
    fleetType: FleetTypeSlug.car,
    fleetTypeId: "9972e1db-ab86-e611-80e8-c4346bc5977c"
  }
];
var fleetCategories_default = FleetCategories;
export {
  AgentPaymentType_default as AgentPaymentType,
  AgentRateType_default as AgentRateType,
  AvailabilityType_default as AvailabilityType,
  FleetTypeSlug,
  JucyCountryCode_default as JucyCountryCode,
  ReservationStatusType_default as ReservationStatusType,
  agentPaymentIdToType,
  branchTimezones_default as branchTimezones,
  branches_default as branches,
  businessUnits_default as businessUnits,
  Countries_default as countries,
  countryWhiteList_default as countryWhiteList,
  fleetCategories_default as fleetCategories,
  fleetTypes_default as fleetTypes,
  stringToAgentRateType,
  stringToReservationStatusType
};
//# sourceMappingURL=index.mjs.map